module.exports = __webpack_public_path__ + "static/media/IconRightDetails.cd527df1.svg";